(function () {
  'use strict';

  if (window.spCustomerGallery) { window.spCustomerGallery.init(); return; }

  function setupGallery(gallery) {
    if (gallery.dataset.spGalleryReady === 'true') return;
    var viewport = gallery.querySelector('.sp-customer-gallery__viewport');
    var group = gallery.querySelector('.sp-customer-gallery__group');
    if (!viewport || !group) return;
    gallery.dataset.spGalleryReady = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var period = group.getBoundingClientRect().width;
    var frame = 0, lastTime = 0, resumeAt = 0, position = 0;
    var manualScrolling = false, autoActive = false, pointerDown = false, touching = false;
    var focused = false, inView = !('IntersectionObserver' in window);
    var drag = null;

    function pauseForInteraction() {
      resumeAt = performance.now() + 6000;
      autoActive = false;
      manualScrolling = true;
    }

    function motionAllowed() {
      return inView && !document.hidden && !reducedMotion.matches;
    }

    function tick(now) {
      frame = 0;
      if (!motionAllowed()) { lastTime = 0; autoActive = false; return; }
      var elapsed = lastTime ? Math.min(now - lastTime, 50) : 0;
      lastTime = now;
      if (period > viewport.clientWidth && !pointerDown && !touching && !focused && now >= resumeAt) {
        if (!autoActive) {
          position = viewport.scrollLeft % period;
          if (position <= 0) position = period;
          autoActive = true;
          manualScrolling = false;
        }
        position -= period * elapsed / 220000;
        if (position <= 0) position += period;
        viewport.scrollLeft = position;
      } else {
        autoActive = false;
      }
      frame = window.requestAnimationFrame(tick);
    }

    function updateMotion() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      lastTime = 0;
      autoActive = false;
      if (motionAllowed()) frame = window.requestAnimationFrame(tick);
    }

    function measure() {
      period = group.getBoundingClientRect().width;
      autoActive = false;
    }

    viewport.addEventListener('scroll', function () {
      if (manualScrolling) resumeAt = performance.now() + 6000;
    }, { passive: true });
    viewport.addEventListener('wheel', pauseForInteraction, { passive: true });
    viewport.addEventListener('touchstart', function () {
      touching = true;
      pauseForInteraction();
    }, { passive: true });
    function finishTouch(event) {
      touching = event.touches.length > 0;
      pauseForInteraction();
    }
    viewport.addEventListener('touchend', finishTouch, { passive: true });
    viewport.addEventListener('touchcancel', finishTouch, { passive: true });
    viewport.addEventListener('pointerdown', function (event) {
      focused = false;
      pointerDown = true;
      pauseForInteraction();
      if (event.pointerType === 'mouse' && event.button === 0) {
        drag = { id: event.pointerId, x: event.clientX, scroll: viewport.scrollLeft };
        viewport.setPointerCapture(event.pointerId);
      }
    }, { passive: true });
    viewport.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      viewport.scrollLeft = drag.scroll - (event.clientX - drag.x);
      pauseForInteraction();
      event.preventDefault();
    });
    function finishPointer(event) {
      if (drag && event.pointerId === drag.id) {
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        drag = null;
      }
      if (pointerDown) {
        pointerDown = false;
        pauseForInteraction();
      }
    }
    window.addEventListener('pointerup', finishPointer, { passive: true });
    window.addEventListener('pointercancel', finishPointer, { passive: true });
    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });
    viewport.addEventListener('focusin', function () {
      focused = viewport.matches(':focus-visible');
      pauseForInteraction();
    });
    viewport.addEventListener('focusout', function (event) {
      if (!viewport.contains(event.relatedTarget)) { focused = false; pauseForInteraction(); }
    });
    viewport.addEventListener('keydown', function () { focused = true; pauseForInteraction(); });
    document.addEventListener('visibilitychange', updateMotion);
    reducedMotion.addEventListener('change', function () { measure(); updateMotion(); });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(group);
    else window.addEventListener('resize', measure, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        updateMotion();
      }).observe(viewport);
    }
    if (!reducedMotion.matches) viewport.scrollLeft = period;
    updateMotion();
  }

  function init() {
    document.querySelectorAll('[data-sp-customer-gallery]').forEach(setupGallery);
  }

  window.spCustomerGallery = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
